<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('订单编号')" prop="orderId">
                <a-input v-model="queryParam.orderId" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('订单编号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('物流公司')" prop="logisticsName">
                <a-input v-model="queryParam.logisticsName" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('物流公司')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('物流单号')" prop="logisticsNo">
                <a-input v-model="queryParam.logisticsNo" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('物流单号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('发货人手机号')" prop="deliveryMobile">
                <a-input v-model="queryParam.deliveryMobile" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('发货人手机号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('发货开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                               :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('发货结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                               :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['order:delivery:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <a-button type="primary" :disabled="multiple"  @click="handleSelectExport" v-hasPermi="['order:delivery:export']">
          <a-icon type="download" />{{$t('选中导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <detail-form
        ref="detailForm"
        @ok="getList"
      />
      <logistic-detail
        ref="logisticDetail"
      />
      <delivery-update-form ref="deliveryUpdateForm" @ok="getList"/>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="orderType" slot-scope="text, record">
           <custom-dict-tag :options="customDict.OrderTypeEnum" :value="record.type"/>
        </span>
        <span slot="orderId" slot-scope="text, record">
          <a @click="$refs.detailForm.handleDetail(record.orderId)">{{record.orderId}}</a>
        </span>
        <template slot="logisticsLogo" slot-scope="text, record">
          <div>
            <img v-if="record.logisticsLogo" :src="record.logisticsLogo"  style="width:60px;height:62px;" @click="handleRecordPreview(record.logisticsLogo)" alt="none"/>
          </div>
        </template>
        <span slot="operation" slot-scope="text, record">
            <a-divider type="vertical"/>
            <a @click="$refs.logisticDetail.handleDetail(record.id)">
              <a-icon type="environment" />{{$t('物流详情')}}
            </a>
           <a-divider type="vertical"/>
            <a @click="$refs.deliveryUpdateForm.handleDelivery(record.id)">
              <a-icon type="edit" />修改
            </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDelivery,listDelivery, delDelivery } from '@/api/order/delivery'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import DetailForm from '../sell/modules/detailForm'
import LogisticDetail from '../sell/modules/LogisticDetail'
import DeliveryUpdateForm from "@/views/order/delivery/DeliveryUpdateForm";
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Delivery',
  components: {
    CustomDictTag,
    DetailForm,
    LogisticDetail,
    DeliveryUpdateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        type: null,
        orderId: null,
        deliveryMobile: undefined,
        createBeginTime:undefined,
        createEndTime:undefined,
        deliveryType: null,
        logisticsId: null,
        logisticsName: null,
        logisticsNo: null,
        receiveAddress: null,
        goodsDetail: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('发货记录编号'),
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('订单类型'),
          dataIndex: 'type',
          scopedSlots: { customRender: 'orderType' },
          align: 'center'
        },
        {
          title: this.$t('订单编号'),
          scopedSlots: { customRender: 'orderId' },
          dataIndex: 'orderId',
          align: 'center'
        },
        {
          title: this.$t('发货方式'),
          dataIndex: 'deliveryType',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('发货人手机号'),
          dataIndex: 'deliveryMobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('物流公司'),
          dataIndex: 'logisticsName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('公司logo'),
          dataIndex: 'logisticsLogo',
          scopedSlots: { customRender: 'logisticsLogo' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('物流单号'),
          dataIndex: 'logisticsNo',
          align: 'center'
        },
        {
          title: this.$t('发货时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('发货备注'),
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询订单发货记录列表 */
    getList () {
      this.loading = true
      pageDelivery(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        type: undefined,
        orderId: undefined,
        deliveryMobile: undefined,
        createBeginTime:undefined,
        createEndTime:undefined,
        deliveryType: undefined,
        logisticsId: undefined,
        logisticsName: undefined,
        logisticsNo: undefined,
        receiveAddress: undefined,
        goodsDetail: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('order/delivery/export',
            that.queryParam
          , `订单发货记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出选中数据'),
        onOk () {
          that.download('order/delivery/export', queryParam, `订单发货记录_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple=true
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple=true
          that.selectedRowKeys=[]
        }
      })
    }
  }
}
</script>
<style>
.custom-link {
  color: blue; /* 文字颜色 */
  text-decoration: underline; /* 下划线 */
  cursor: pointer; /* 鼠标悬停时的样式，通常表示可点击 */
}

</style>